import { SVGProps } from 'react'

const AuctionsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m11.316 7.178 3.842-3.842a.024.024 0 0 0 0-.035l-1.223-1.223a.025.025 0 0 0-.034 0l-3.843 3.843a.025.025 0 0 0 0 .035l1.223 1.222c.01.01.025.01.034 0Zm4.373-3.312a.775.775 0 0 0 0-1.096l-1.223-1.222a.775.775 0 0 0-1.096 0L9.528 5.39a.775.775 0 0 0 0 1.096l1.222 1.223a.775.775 0 0 0 1.096 0l.171-.172.029.028 1.4 1.401-.223.217L1.59 20.51a.775.775 0 0 0-.015 1.095l.819.84a.775.775 0 0 0 1.095.016l11.635-11.326.249-.243.916.917.14.14-.17.172a.775.775 0 0 0 0 1.095l1.222 1.223a.775.775 0 0 0 1.096 0l3.843-3.843a.775.775 0 0 0 0-1.095l-1.223-1.223a.775.775 0 0 0-1.096 0l-.336.337-.14-.141L15.38 4.23l-.029-.028.337-.336Zm2.357 10.042 3.842-3.843a.025.025 0 0 0 0-.035l-1.223-1.223a.025.025 0 0 0-.034 0l-3.843 3.843a.025.025 0 0 0 0 .035l1.223 1.223c.01.01.025.01.035 0Zm1.047-4.905L14.85 4.761l-2.274 2.274 4.243 4.242 2.274-2.274Zm-5.346.718L2.112 21.046a.025.025 0 0 0 0 .035l.818.84c.01.01.025.01.035.001l11.634-11.325-.852-.876Z"
    />
  </svg>
)

export default AuctionsIcon
